import { render, staticRenderFns } from "./HTMLDialog.vue?vue&type=template&id=987852f8&scoped=true&"
import script from "./HTMLDialog.vue?vue&type=script&lang=js&"
export * from "./HTMLDialog.vue?vue&type=script&lang=js&"
import style0 from "./HTMLDialog.vue?vue&type=style&index=0&id=987852f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987852f8",
  null
  
)

export default component.exports